import React, { useEffect, useRef } from "react";
import useNetworkStatus from "../networkStatus/useNetworkStatus";
import { toast } from "react-toastify";
import debounce from "../utils/debounce";
import { getAllBookingResources } from "../booking/duck/BookingActions";
import { useSelector, useDispatch } from "react-redux";

const NetworkStatus = () => {
  const isOnline = useNetworkStatus();
  const previousStatus = useRef(isOnline);
  const dispatch = useDispatch();

  const debounceReload = useRef(
      debounce((params) => {
        dispatch(getAllBookingResources(params));
      }, 1000)
  ).current;

  const { activeWorkSpace } = useSelector(({ workSpace }) => {
    const { workSpaceMap, active } = workSpace;
    return {
      activeWorkSpace: active,
      mWorkspace: workSpaceMap[active],
    };
  });


  useEffect(() => {
    if (previousStatus.current !== isOnline) {
      if (!isOnline) {
        toast.error("Connection lost. You're offline.");
      } else {
        const params = {
          page: "Calendar",
          space_id: activeWorkSpace,
          offset: 0,
          limit: 100,
        };
        debounceReload(params);
        toast.success("Connection restored. You're back online.");
      }
      previousStatus.current = isOnline;
    }
  }, [isOnline, activeWorkSpace]);

  return null;
};

export default NetworkStatus;
